import type { ActiveStatus } from "@/types";

export type FlagTypes =
  | "newPlanner"
  | "matomoLogs"
  | "domCounter"
  | "performanceLogs";

export const toFlagKey = (key: FlagTypes) => {
  return `flags:${key}`;
};

export const getFlagStatus = (key: FlagTypes): ActiveStatus => {
  return (localStorage.getItem(toFlagKey(key)) || "off") as ActiveStatus;
};

export const isFlagActive = (key: FlagTypes): boolean => {
  return getFlagStatus(key) === "on";
};
